




import React, { Component } from 'react';
import { SketchPicker } from 'react-color';
import axios from 'axios';
import Cookies from 'universal-cookie'; 
import Frame from 'react-frame-component';
import {BeautifulCircleIcon} from './BeautifulCircleIcon';



export class DesktopRedDesign extends React.Component {




    constructor(props) {
        super(props)
    }

    render() {
        return (
            <div style={{'marginLeft': '3em', 'verticalAlign': 'middle'}} className='whiteBlock'>  
                 <div className='whiteBlockTitle'>
                        <BeautifulCircleIcon/>
                            <div className='whiteBlockTitleSpan'>
                                Дизайн
                            </div>
                        </div>
                        <div style={{'marginTop': '1em'}}>
                            <span onClick={(e) => {
                                this.props.setDefault()
                            }} className="clearPhotoSpan">
                                Вернуться к дефолтной версии
                            </span>
                        </div>
            <div className= 'designBlock' >
                        
            <div className= 'inputsBlock_block' >
                    <div style={{ 'textAlign':'left'}} className= 'inputsBlock_block_label whiteBlockTextInputBlock_label'>
        
                    Цвет кнопки
                    </div>
                    <div onClick={(e) => {
                       this.props.showColorPicker('btn')
                    }} className="colorBlock">
                        <div style={{'background': this.props.btnColorHex}} className='colorBlockItself'>

                        </div>
                        <div ref={this.props.colorPickerBtnColorRef} className={
                            this.props.showColorPickerBtnColor ?
                            'colorPicker':
                            'colorPicker hidden'
                        }>
                        <SketchPicker
                        disableAlpha ={true}
                color={ this.props.btnColor }
                onChange ={(e) => {
                    this.props.handleChangeComplete(e, 'btn')
                } }
                 />
                        </div>
                    </div>
                   {/* */} 
        
            </div>
            

            <div className= 'inputsBlock_block' >
                    <div style={{ 'textAlign':'left'}} className= 'inputsBlock_block_label whiteBlockTextInputBlock_label'>
        
                     Цвет фона 1
                    </div>
                    <div  onClick={(e) => {
                       this.props.showColorPicker('bg1')
                    }}  className="colorBlock">
                        <div style={{'background': this.props.bg1ColorHex}} className='colorBlockItself'>

                        </div>
                        <div ref={this.props.colorPickerBg1ColorRef} className={
                            this.props.showColorPickerBg1Color ?
                            'colorPicker':
                            'colorPicker hidden'
                        }>
                        <SketchPicker

                color={ this.props.bg1Color }
                onChange ={(e) => {
                    this.props.handleChangeComplete(e, 'bg1')
                } }
                 />
                        </div>
                    </div>
                   {/* */} 
        
            </div>
            



            <div className= 'inputsBlock_block' >
                    <div style={{ 'textAlign':'left'}} className= 'inputsBlock_block_label whiteBlockTextInputBlock_label'>
        
                     Цвет фона 2
                    </div>
                    <div onClick={(e) => {
                        this.props.showColorPicker('bg2')
                    }} className="colorBlock">
                        <div style={{'background': this.props.bg2ColorHex}} className='colorBlockItself'>

                        </div>
                        <div ref={this.props.colorPickerBg2ColorRef} className={
                            this.props.showColorPickerBg2Color ?
                            'colorPicker':
                            'colorPicker hidden'
                        }>
                        <SketchPicker

                color={ this.props.bg2Color }
                onChange ={(e) => {
                    this.props.handleChangeComplete(e, 'bg2')
                } }
                 />
                        </div>
                    </div>
                   {/* */} 
        
            </div>

            <div className= 'inputsBlock_block' >
                    <div style={{ 'textAlign':'left'}} className= 'inputsBlock_block_label whiteBlockTextInputBlock_label'>
        
                     Цвет фона mobile
                    </div>
                    <div onClick={(e) => {
                        this.props.showColorPicker('bgMobile')
                    }} className="colorBlock">
                        <div style={{'background': this.props.bgMobileColorHex}} className='colorBlockItself'>

                        </div>
                        <div ref={this.props.colorPickerBgMobileColorRef} className={
                            this.props.showColorPickerBgMobileColor ?
                            'colorPicker':
                            'colorPicker hidden'
                        }>
                        <SketchPicker

                color={ this.props.bgMobileColor }
                onChange ={(e) => {
                    this.props.handleChangeComplete(e, 'bgMobile')
                } }
                 />
                        </div>
                    </div>
                   {/* */} 
        
            </div>
            <div className= 'inputsBlock_block' >
                    <div style={{  'textAlign':'left'}} className= 'inputsBlock_block_label whiteBlockTextInputBlock_label'>
        
                    Цвет текста кнопки
                    </div>
                    <div onClick={(e) => {
                        this.props.showColorPicker('btnText')
                    }} className="colorBlock">
                        <div style={{'background': this.props.btnTextColorHex}} className='colorBlockItself'>

                        </div>
                        <div ref={this.props.colorPickerBtnTextColorRef} className={
                            this.props.showColorPickerBtnTextColor ?
                            'colorPicker':
                            'colorPicker hidden'
                        }>
                        <SketchPicker
                disableAlpha ={true}
                color={ this.props.btnTextColor }
                onChange ={(e) => {
                    this.props.handleChangeComplete(e, 'btnText')
                } }
                 />
                        </div>
                    </div>
                   {/* */} 
        
            </div>
            
         
            
            <div className= 'inputsBlock_block' >
                    <div style={{ 'textAlign':'left'}} className= 'inputsBlock_block_label whiteBlockTextInputBlock_label'>
        
                    Цвет заголовка
                    </div>
                    <div onClick={(e) => {
                        this.props.showColorPicker('h1')
                    }} className="colorBlock">
                        <div style={{'background': this.props.h1ColorHex}} className='colorBlockItself'>

                        </div>
                        <div ref={this.props.colorPickerH1ColorRef} className={
                            this.props.showColorPickerH1Color ?
                            'colorPicker':
                            'colorPicker hidden'
                        }>
                        <SketchPicker
                        disableAlpha ={true}
                color={ this.props.h1Color }
                onChange ={(e) => {
                    this.props.handleChangeComplete(e, 'h1')
                } }
                 />
                        </div>
                    </div>
                   {/* */} 
        
            </div>


            
            
            <div className= 'inputsBlock_block' >
                    <div style={{ 'textAlign':'left'}} className= 'inputsBlock_block_label whiteBlockTextInputBlock_label'>
        
                    Цвет  текста
                    </div>
                    <div onClick={(e) => {
                       this.props.showColorPicker('h2')
                    }} className="colorBlock">
                        <div style={{'background': this.props.h2ColorHex}} className='colorBlockItself'>

                        </div>
                        <div ref={this.props.colorPickerH2ColorRef} className={
                            this.props.showColorPickerH2Color ?
                            'colorPicker':
                            'colorPicker hidden'
                        }>
                        <SketchPicker
                        disableAlpha ={true}
                color={ this.props.h2Color }
                onChange ={(e) => {
                    this.props.handleChangeComplete(e, 'h2')
                } }
                 />
                        </div>
                    </div>
                   {/* */} 
        
            </div>

            

            <div className= 'inputsBlock_block' >
                    <div style={{ 'textAlign':'left'}} className= 'inputsBlock_block_label whiteBlockTextInputBlock_label'>
        
                    Цвет  лого clientsaver
                    </div>
                    <div onClick={(e) => {
                        this.props.showColorPicker('logo')
                    }} className="colorBlock">
                        <div style={{'background': this.props.logoColorHex}} className='colorBlockItself'>

                        </div>
                        <div ref={this.props.colorPickerLogoColorRef} className={
                            this.props.showColorPickerLogoColor ?
                            'colorPicker':
                            'colorPicker hidden'
                        }>
                        <SketchPicker
                        disableAlpha ={true}
                color={ this.props.logoColor }
                onChange ={(e) => {
                    this.props.handleChangeComplete(e, 'logo')
                } }
                 />
                        </div>
                    </div>
                   {/* */} 
        
            </div>

            </div>
                            </div>




        )
    
    }
}